import { render } from "./BulkMetricsModal.vue?vue&type=template&id=376d5a0d&scoped=true"
import script from "./BulkMetricsModal.vue?vue&type=script&lang=js"
export * from "./BulkMetricsModal.vue?vue&type=script&lang=js"

import "./BulkMetricsModal.vue?vue&type=style&index=0&id=376d5a0d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-376d5a0d"]])

export default __exports__